import React from "react";
import { Table } from "reactstrap";
import TableSkeleton from "../Skeleton/TableSkeleton";
import WebsiteIdentityCell from "./WebsiteIdentityCell";
import ComparisonTableCell from "./ComparisonTableCell";

export const METRIC_COLUMNS = [
	{ key: "totalSearches", label: "Searches", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "searchConversionRate", label: "Search Conv. Rate", format: "percent", deltaType: "points", positiveIsGood: true },
	{ key: "searchConversions", label: "Search Conversions", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "collectionConversionRate", label: "Collection Conv. Rate", format: "percent", deltaType: "points", positiveIsGood: true },
	{ key: "collectionConversions", label: "Collection Conversions", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "zeroResultSearches", label: "Zero Results", format: "number", deltaType: "number", positiveIsGood: false },
	{ key: "totalClicks", label: "Clicks", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "addToCart", label: "Add to Cart", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "searchRevenue", label: "Search Revenue", format: "currency", deltaType: "number", positiveIsGood: true },
	{ key: "collectionRevenue", label: "Collection Revenue", format: "currency", deltaType: "number", positiveIsGood: true },
];

const PlatformAnalyticsTable = ({
	rows = [],
	loading = false,
	onDownloadMetric,
	exportingKey = null,
}) => {
	if (loading && rows.length === 0) {
		return <TableSkeleton />;
	}

	const colSpan = METRIC_COLUMNS.length + 1;

	return (
		<div className="platformAnalyticsTableWrapper mt-3">
			<Table className={`table ${rows.length > 0 ? "table-striped" : ""} custom-bordered-table platformAnalyticsTable`}>
				<thead>
					<tr>
						<th className="websiteIdentityHeader">Company</th>
						{METRIC_COLUMNS.map((col) => (
							<th key={col.key}>
								{col.label}
								{col.exportable ? (
									<span className="metricExportHint" title="Click a value to download XLSX">
										{" "}↓
									</span>
								) : null}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.length === 0 ? (
						<tr>
							<td colSpan={colSpan}>
								<div className="emptyPlaceholder">
									<div>
										<div>
											<img
												src={require("../../assets/images/paper-plane-grey.png")}
												className="img-fluid"
												alt="No data found"
											/>
										</div>
										<div className="rsInfoMsg disabled">
											<div className="flex-1">No records found.</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					) : (
						rows.map((row) => (
							<tr key={row.websiteId}>
								<WebsiteIdentityCell
									websiteId={row.websiteId}
									websiteUrl={row.websiteUrl}
									companyName={row.companyName}
								/>
								{METRIC_COLUMNS.map((col) => {
									const exportKey = `${row.websiteId}:${col.key}`;
									return (
										<ComparisonTableCell
											key={col.key}
											metric={row[col.key]}
											format={col.format}
											deltaType={col.deltaType}
											positiveIsGood={col.positiveIsGood}
											exportable={Boolean(col.exportable && onDownloadMetric)}
											exporting={exportingKey === exportKey}
											exportLabel={`Download ${col.label} data (XLSX)`}
											onExport={() =>
												onDownloadMetric({
													websiteId: row.websiteId,
													metricKey: col.key,
													label: col.label,
												})
											}
										/>
									);
								})}
							</tr>
						))
					)}
				</tbody>
			</Table>
		</div>
	);
};

export default PlatformAnalyticsTable;
